import React, { useState, useEffect } from "react";
import { Row, Col, Accordion, Card, Button, Table } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import SummaryCard from "./SummaryCard.jsx";
import classes from "./StaffSalesAnalysis.module.css";
import ReactExport from "react-export-excel-fixed-xlsx";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const StaffSalesAnalysis = (props) => {
  const [RetrievedStaffRecords, setRetrievedStaffRecords] = useState([]);
  const [Title, setTitle] = useState("");
  const [DisplayData, setDisplayData] = useState(false);
  const [Rct, setRct] = useState({});
  const [CardTotalSales, setCardTotalSales] = useState(0);
  const [CardCash, setCardCash] = useState(0);
  const [CardPOS, setCardPOS] = useState(0);
  const [CardTransfer, setCardTransfer] = useState(0);
  const [CardCredit, setCardCredit] = useState(0);
  const [IsPrinting, setIsPrinting] = useState(false);
  const [DisplaySummary, setDisplaySummary] = useState(false);

  useEffect(() => {
    let Records = props.Records;
    let TotalSales = 0;
    let TotalCash = 0;
    let TotalPOS = 0;
    let TotalCredit = 0;
    let TotalTransfer = 0;

    const getCardTotal = (AllSales) => {
      for (var p = 0; p < AllSales.length - 1; p++) {
        TotalSales += parseFloat(AllSales[p]["TotalSales"]);
        TotalCash += parseFloat(AllSales[p]["Cash"]);
        TotalPOS += parseFloat(AllSales[p]["POS"]);
        TotalTransfer += parseFloat(AllSales[p]["Transfer"]);
        TotalCredit += parseFloat(AllSales[p]["Credit"]);
      }
    };

    if (props.myDates.type === "specific") {
      let ALLSALES =
        Records.ThisStaffRecords !== null ? Records.ThisStaffRecords : [];

      getCardTotal(ALLSALES);
    } else {
      let ALLSALES = Records;
      for (var m = 1; m < ALLSALES.length; m++) {
        if (props.myDates.Category !== "Individual") {
          getCardTotal(ALLSALES[m]["ThisStaffRecords"]);
        } else {
          let Temp = ALLSALES[m]["ThisStaffRecords"];

          if (Temp["StaffName"]) {
            TotalSales += parseFloat(
              ALLSALES[m]["ThisStaffRecords"]["TotalSales"]
            );
            TotalCash += ALLSALES[m]["ThisStaffRecords"]["Cash"];
            TotalPOS += ALLSALES[m]["ThisStaffRecords"]["POS"];
            TotalTransfer += ALLSALES[m]["ThisStaffRecords"]["Transfer"];
            TotalCredit += ALLSALES[m]["ThisStaffRecords"]["Credit"];
          }
        }
      }
    }

    setCardTotalSales(TotalSales);
    setCardCash(TotalCash);
    setCardPOS(TotalPOS);
    setCardTransfer(TotalTransfer);
    setCardCredit(TotalCredit);
    setRetrievedStaffRecords(Records);
    setDisplayData(true);
    if (props.myDates.type === "specific") {
      setTitle((" for " + props.myDates.dates).toUpperCase());
    } else {
      let thedates = [...props.myDates.dates];
      setTitle(
        (
          "from " +
          thedates[0] +
          " to " +
          thedates[thedates.length - 1] +
          "."
        ).toUpperCase()
      );
    }
  }, []);

  const ExportToExcel = (ArrData, indx) => {
    return (
      <ExcelSheet
        data={ArrData.ThisStaffRecords}
        name={ArrData.ThisDate}
        key={indx}
      >
        <ExcelColumn label="STAFF NAME" value="StaffName" />
        <ExcelColumn label="CASH" value="Cash" />
        <ExcelColumn label="POS" value="Pos" />
        <ExcelColumn label="TRANSFER" value="Transfer" />
        <ExcelColumn label="CREDIT" value="Credit" />
        <ExcelColumn label="NO OF ITEMS Transactions" value="TransactionNo" />
        <ExcelColumn label="TOTAL" value="TotalSales" />
      </ExcelSheet>
    );
  };

  const getTableCode = (ArrData, ind) => {
    let DataPresent = true;
    if (
      ArrData.ThisStaffRecords != undefined &&
      ArrData.ThisStaffRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }

    return (
      <Row className="justify-content-around " key={ind}>
        <Col md={12} sm={11} xs={11}>
          <Accordion.Item eventKey={ind}>
            <Accordion.Header className={classes.TheHeader}>
              {ArrData.ThisDate}
            </Accordion.Header>
            <Accordion.Body>
              {DataPresent && (
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Staff Name</th>
                      <th>Cash</th>
                      <th>POS</th>
                      <th>Transfer</th>
                      <th>Credit</th>
                      <th>No of Transactions</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {ArrData.ThisStaffRecords.map((rec, index) => (
                      <tr key={index}>
                        <td>
                          {index < ArrData.ThisStaffRecords.length - 1
                            ? index + 1
                            : ""}
                        </td>
                        <td>{rec.StaffName}</td>
                        <td>{rec.Cash}</td>
                        <td>{rec.POS}</td>
                        <td>{rec.Transfer}</td>
                        <td>{rec.Credit}</td>
                        <td>{rec.TransactionNo}</td>
                        <td>{rec.TotalSales}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
              {!DataPresent && (
                <p style={{ color: "Red", fontSize: "15px" }}>
                  Oops! No Record for {ArrData.ThisDate}
                </p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Col>
      </Row>
    );
  };

  const getTableCodeIndividual = (ArrData, ind) => {
    let DataPresent = true;
    if (ArrData.ThisStaffRecords.StaffName) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    return (
      <Row className="justify-content-around " key={ind}>
        <Col md={12} sm={11} xs={11}>
          <Accordion.Item eventKey={ind}>
            <Accordion.Header className={classes.TheHeader}>
              {ArrData.ThisDate}
            </Accordion.Header>
            <Accordion.Body>
              {DataPresent && (
                <Table striped bordered responsive>
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Staff Name</th>
                      <th>Cash</th>
                      <th>POS</th>
                      <th>Transfer</th>
                      <th>Credit</th>
                      <th>No of Transactions</th>
                      <th>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1.</td>
                      <td>{ArrData.ThisStaffRecords.StaffName}</td>
                      <td>{ArrData.ThisStaffRecords.Cash}</td>
                      <td>{ArrData.ThisStaffRecords.POS}</td>
                      <td>{ArrData.ThisStaffRecords.Transfer}</td>
                      <td>{ArrData.ThisStaffRecords.Credit}</td>
                      <td>{ArrData.ThisStaffRecords.TransactionNo}</td>
                      <td>{ArrData.ThisStaffRecords.TotalSales}</td>
                    </tr>
                  </tbody>
                </Table>
              )}
              {!DataPresent && (
                <p style={{ color: "Red", fontSize: "15px" }}>
                  Oops! No Record for {ArrData.ThisDate}
                </p>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Col>
      </Row>
    );
  };

  const TableForPrinting = (ArrData, indx) => {
    let DataPresent = true;
    if (
      ArrData.ThisStaffRecords != undefined &&
      ArrData.ThisStaffRecords.length > 0
    ) {
      DataPresent = true;
    } else {
      DataPresent = false;
    }
    return (
      <div key={indx}>
        {props.myDates.Category === "Individual" &&
          props.myDates.Staff.toUpperCase() + " "}
        STAFF SALES REPORT FOR {ArrData.ThisDate.toUpperCase()}
        {DataPresent && (
          <Table
            striped
            bordered
            responsive
            key={indx}
            className={classes.table4printing}
          >
            <thead>
              <tr>
                <th>SN</th>
                <th>Staff Name</th>
                <th>Cash</th>
                <th>POS</th>
                <th>Transfer</th>
                <th>Credit</th>
                <th>No of Transactions</th>
                <th>Total</th>
              </tr>
            </thead>
            <tbody>
              {ArrData.ThisStaffRecords.map((rec, index) => (
                <tr key={index}>
                  <td>
                    {index < ArrData.ThisStaffRecords.length - 1
                      ? index + 1
                      : ""}
                  </td>
                  <td>{rec.StaffName}</td>
                  <td>{rec.Cash}</td>
                  <td>{rec.POS}</td>
                  <td>{rec.Transfer}</td>
                  <td>{rec.Credit}</td>
                  <td>{rec.TransactionNo}</td>
                  <td>{rec.TotalSales}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
        {!DataPresent && <p>Oops! No Record for {ArrData.ThisDate}</p>}
        <hr />
      </div>
    );
  };

  const PrintTheReport = () => {
    setIsPrinting(true);
    window.print();
    setIsPrinting(false);
  };

  return (
    <Row className={classes.margin4printing}>
      <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
        {DisplayData && (
          <Row className={classes.margin4printing}>
            <Col md={12} sm={12} xs={12} className={classes.hide4printing}>
              <p
                style={{
                  fontFamily: "Times New Roman",
                  fontSize: "20px",
                  color: "brown",
                  textAlign: "center",
                }}
              >
                {props.myDates.Category === "Individual" &&
                  props.myDates.Staff.toUpperCase() + " "}
                STAFF SALES REPORTS {Title}
              </p>
            </Col>
            <Col md={2} className={`${classes.hide4printing} ${"px-4"}`}>
              <Card>
                <Card.Header className={classes.TheHeader}>
                  SUMMARY OF THE SELECTED DATES
                </Card.Header>
                <Card.Body>
                  <Button
                    variant="info"
                    className="btn w-100 mt-2 mb-2 rounded-0"
                    onClick={() =>
                      setDisplaySummary(
                        (prevDisplaySummary) => !prevDisplaySummary
                      )
                    }
                  >
                    {DisplaySummary ? "Hide Summary" : "Display Summary"}
                  </Button>
                  <SummaryCard
                    Title="Total Sales "
                    Value={CardTotalSales}
                    dispSum={DisplaySummary}
                  />
                  <br />
                  <SummaryCard
                    Title="Payment by Cash "
                    Value={CardCash}
                    dispSum={DisplaySummary}
                  />
                  <br />
                  <SummaryCard
                    Title="Payment by POS "
                    Value={CardPOS}
                    dispSum={DisplaySummary}
                  />
                  <br />
                  <SummaryCard
                    Title="Payment by Transfer "
                    Value={CardTransfer}
                    dispSum={DisplaySummary}
                  />
                  <br />
                  <SummaryCard
                    Title="On Credit "
                    Value={CardCredit}
                    dispSum={DisplaySummary}
                  />
                  <br />
                </Card.Body>
              </Card>
            </Col>
            <Col md={10} sm={12} xs={12} className={classes.margin4printing}>
              <Row
                className={`${
                  classes.margin4printing
                } ${"justify-content-around"}`}
              >
                <Col md={12} sm={12} xs={12} className={classes.hide4printing}>
                  <Accordion>
                    {props.myDates.Category === "Individual"
                      ? props.myDates.type === "specific"
                        ? getTableCodeIndividual(RetrievedStaffRecords, 0)
                        : RetrievedStaffRecords.map((rtrvrec, index) =>
                            getTableCodeIndividual(rtrvrec, index)
                          )
                      : props.myDates.type === "specific"
                      ? getTableCode(RetrievedStaffRecords, 0)
                      : RetrievedStaffRecords.map((rtrvrec, index) =>
                          getTableCode(rtrvrec, index)
                        )}
                  </Accordion>
                </Col>
                <Col
                  md={12}
                  sm={12}
                  xs={12}
                  className={classes.margin4printing}
                >
                  {IsPrinting
                    ? props.myDates.type === "specific"
                      ? TableForPrinting(RetrievedStaffRecords, 0)
                      : RetrievedStaffRecords.map((rtrvrec, index) =>
                          TableForPrinting(rtrvrec, index)
                        )
                    : null}
                  {IsPrinting && (
                    <Row>
                      <Col md={3}>
                        <SummaryCard
                          Title="Total Sales "
                          Value={CardTotalSales}
                        />
                      </Col>
                      <Col md={3}>
                        <SummaryCard
                          Title="Payment by Cash "
                          Value={CardCash}
                        />
                      </Col>
                      <Col md={3}>
                        <SummaryCard Title="Payment by POS " Value={CardPOS} />
                      </Col>
                      <Col md={3}>
                        <SummaryCard
                          Title="Payment by Transfer "
                          Value={CardTransfer}
                        />
                      </Col>
                      <Col md={3}>
                        <SummaryCard
                          Title="Payment by Transfer "
                          Value={CardTransfer}
                        />
                      </Col>
                      <Col md={3}>
                        <SummaryCard
                          Title="Payment by Credit "
                          Value={CardCredit}
                        />
                      </Col>
                    </Row>
                  )}
                </Col>
                <hr className={`${classes.hide4printing} ${"mx-2"}`} />
                <Col md={2} sm={6} xs={6} className={classes.hide4printing}>
                  <Button variant="info" onClick={PrintTheReport}>
                    Print
                  </Button>
                </Col>

                <Col md={2} sm={12} xs={12} className={classes.hide4printing}>
                  <ExcelFile
                    element={
                      <Button variant="info" className="my-2">
                        EXPORT TO EXCEL
                      </Button>
                    }
                    filename={
                      (props.myDates.Category === "Individual"
                        ? props.myDates.Staff.toUpperCase()
                        : "") +
                      "STAFF SALES REPORT FOR " +
                      (props.myDates.type === "specific"
                        ? RetrievedStaffRecords.ThisDate
                        : RetrievedStaffRecords[0].ThisDate +
                          "-" +
                          RetrievedStaffRecords[
                            RetrievedStaffRecords.length - 1
                          ].ThisDate
                      ).toUpperCase()
                    }
                  >
                    {props.myDates.type === "specific"
                      ? ExportToExcel(RetrievedStaffRecords, 0)
                      : RetrievedStaffRecords.map((rtvdata, ind) =>
                          ExportToExcel(rtvdata, ind)
                        )}
                  </ExcelFile>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  );
};

export default StaffSalesAnalysis;
